import { resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4e585ae0")

_pushScopeId("data-v-4e585ae0")
const _hoisted_1 = { class: "w-full flex flex-row mb-3 md:mb-0" }
const _hoisted_2 = { class: "font-bold w-20 pr-1 md:pr-0 md:w-auto" }
const _hoisted_3 = {
  key: 0,
  class: "text-10px text-gray-lp-600"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Waktu ")
const _hoisted_5 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Internasional")
const _hoisted_7 = { class: "w-11/12 flex" }
const _hoisted_8 = { class: "flex flex-col px-1 mt-1" }
const _hoisted_9 = { class: "flex items-center justify-center" }
const _hoisted_10 = { class: "flex items-center justify-center timeline-mobile" }
const _hoisted_11 = { class: "pl-2" }
const _hoisted_12 = { class: "flex md:items-center items-baseline flex-col md:flex-row mt-1 md:mt-0" }
const _hoisted_13 = { class: "flex flex-row" }
const _hoisted_14 = { class: "flex flex-row mt-2 md:mt-0 items-center" }
const _hoisted_15 = { class: "w-5 flex" }
const _hoisted_16 = { class: "flex flex-row my-1 md:my-0 items-center" }
const _hoisted_17 = { class: "w-5 flex" }
const _hoisted_18 = { class: "flex" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TooltipV2 = _resolveComponent("TooltipV2")!
  const _component_Icons = _resolveComponent("Icons")!
  const _directive_sanitize_html = _resolveDirective("sanitize-html")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: `w-20 pr-1 md:pr-0 md:w-1/12 text-12px ${
        _ctx.active ? 'text-gray-lp-300' : 'text-gray-lp-800'
      }  text-right pr-3 mt-1`
    }, [
      _withDirectives(_createVNode("div", _hoisted_2, null, 512), [
        [_directive_sanitize_html, _ctx.time]
      ]),
      (!!_ctx.internationalTime)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _hoisted_4,
            _hoisted_5,
            _hoisted_6
          ]))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode("div", _hoisted_7, [
      _createVNode("div", _hoisted_8, [
        _createVNode("div", _hoisted_9, [
          _createVNode("div", {
            class: `w-4 h-4 ${
              _ctx.active ? 'bg-red-lp-300' : 'bg-gray-lp-1300'
            }  rounded-full`
          }, null, 2)
        ]),
        _createVNode("div", _hoisted_10, [
          (_ctx.isVerticalLine)
            ? (_openBlock(), _createBlock("div", {
                key: 0,
                class: 
              `w-0.5 h-12 border-2 border-gray-lp-1300 my-1 rounded-md vertical-line-mobile`
            
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.isHalfVerticalLine)
            ? (_openBlock(), _createBlock("div", {
                key: 1,
                class: `w-0.5 h-full md:h-2 border-2 border-gray-lp-1300 my-1 rounded-md vertical-line-mobile`
              }, null, 2))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode("div", _hoisted_11, [
        _createVNode("div", _hoisted_12, [
          _createVNode("div", _hoisted_13, [
            _createVNode("div", {
              class: `text-12px font-bold ${
                _ctx.active ? 'text-gray-lp-300' : 'text-gray-lp-800'
              }`
            }, _toDisplayString(_ctx.status), 3),
            _createVNode(_component_TooltipV2, {
              description: _ctx.tooltip,
              widthIcon: "w-4",
              adjustedPosition: "flex items-center"
            }, null, 8, ["description"])
          ]),
          _createVNode("div", {
            class: `hidden md:flex text-16px pl-1 font-bold ${
              _ctx.active ? 'text-gray-lp-300' : 'text-gray-lp-800'
            }`
          }, " I ", 2),
          _createVNode("div", _hoisted_14, [
            _createVNode("div", _hoisted_15, [
              _createVNode(_component_Icons, {
                name: "user",
                class: `w-5 ${_ctx.active ? 'text-gray-lp-300' : 'text-gray-lp-800'}`
              }, null, 8, ["class"])
            ]),
            _createVNode("div", {
              class: `ml-2 md:ml-0 text-12px font-medium ${
                _ctx.active ? 'text-gray-lp-300' : 'text-gray-lp-800'
              }`,
              innerHTML: _ctx.transitLocation
            }, null, 10, ["innerHTML"]),
            (_ctx.districtCity)
              ? (_openBlock(), _createBlock("div", {
                  key: 0,
                  class: `hidden md:flex text-16px pl-1 font-medium ${
                _ctx.active ? 'text-gray-lp-300' : 'text-gray-lp-800'
              }`
                }, " I ", 2))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_16, [
            _createVNode("div", _hoisted_17, [
              (_ctx.districtCity)
                ? (_openBlock(), _createBlock(_component_Icons, {
                    key: 0,
                    name: "maps",
                    class: `w-5 md:pl-1 ${
                  _ctx.active ? 'text-gray-lp-300' : 'text-gray-lp-800'
                }`
                  }, null, 8, ["class"]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.districtCity)
              ? (_openBlock(), _createBlock("div", {
                  key: 0,
                  class: `ml-2 md:ml-0 text-12px font-medium ${
                _ctx.active ? 'text-gray-lp-300' : 'text-gray-lp-800'
              }`
                }, _toDisplayString(_ctx.districtCity), 3))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode("div", _hoisted_18, [
          _createVNode("div", {
            class: `text-12px font-normal ${
              _ctx.active ? 'text-gray-lp-300' : 'text-gray-lp-800'
            }`,
            onClick: ""
          }, [
            _withDirectives(_createVNode("div", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClickValue && _ctx.onClickValue(...args)))
            }, null, 512), [
              [_directive_sanitize_html, _ctx.description]
            ]),
            (_ctx.proofPod)
              ? (_openBlock(), _createBlock("a", {
                  key: 0,
                  class: "text-red-lp-300 font-normal cursor-pointer hover:underline",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onClickValue && _ctx.onClickValue(...args)))
                }, _toDisplayString(_ctx.$t("trackingCargo.proofPodLink")), 1))
              : _createCommentVNode("", true),
            (_ctx.proofAdjustBook)
              ? (_openBlock(), _createBlock("a", {
                  key: 1,
                  class: "text-red-lp-300 font-normal cursor-pointer hover:underline",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onClickValue && _ctx.onClickValue(...args)))
                }, _toDisplayString(_ctx.$t("trackingCargo.proofAdjustBookLink")), 1))
              : _createCommentVNode("", true)
          ], 2)
        ])
      ])
    ])
  ]))
})